import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_CONFIG } from '@/config/brand';

type NavItem = {
  label: string;
  href: string; // '#features' 或 '/pricing'
};

interface LandingHeaderProps {
  brandName?: string;
  variant?: 'A' | 'B';
  navItems?: NavItem[];
  rightSlot?: React.ReactNode; // CTA 區塊（按鈕等）
}

export const LandingHeader: React.FC<LandingHeaderProps> = ({
  brandName,
  variant = 'A',
  navItems = [],
  rightSlot,
}) => {
  const headerClass =
    variant === 'A'
      ? 'sticky top-0 z-50 w-full border-b border-wedding-pink/10 bg-white/60 backdrop-blur-xl'
      : 'sticky top-0 z-50 w-full border-b border-wedding-pink/20 bg-wedding-bg/80 backdrop-blur-sm';

  const navLinkClass =
    variant === 'A'
      ? 'text-sm font-medium text-gray-600 hover:text-wedding-pink transition-colors'
      : 'text-sm font-medium hover:text-wedding-pink';

  const gapClass = variant === 'A' ? 'gap-2' : 'gap-4';

  return (
    <header className={headerClass}>
      <div className="container mx-auto flex h-16 items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <img src={BRAND_CONFIG.logo} alt={BRAND_CONFIG.logoAlt} className="h-8 w-8" />
          <span className="font-bold text-base md:text-xl text-wedding-text-title whitespace-nowrap">{brandName ?? BRAND_CONFIG.name}</span>
        </Link>
        <nav className="hidden items-center gap-6 md:flex">
          {navItems.map((item) =>
            item.href.startsWith('#') || item.href.startsWith('/#') ? (
              <a key={item.href} href={item.href} className={navLinkClass}>
                {item.label}
              </a>
            ) : (
              <Link key={item.href} to={item.href} className={navLinkClass}>
                {item.label}
              </Link>
            )
          )}
        </nav>
        <div className={`flex items-center ${gapClass}`}>{rightSlot}</div>
      </div>
    </header>
  );
};

